import { Dialog, IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DocumentUploadPage from "../DocumentUpload";

export default function UploadDocumentModal({
  open,
  row,
  docType,
  onClose,
  onSuccess
}) {
  const isBolPodPop = Boolean(docType?.BOL_POD_POP);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <IconButton
        onClick={onClose}
        sx={{ position: "absolute", right: 12, top: 12, zIndex: 1 }}
      >
        <CloseIcon />
      </IconButton>

      <Box>
        <DocumentUploadPage
          defaultControls={[
            {
              controlNo: row.control,
              allowedDocTypes: [docType?.abbrevation],

              defaultDocType: docType
                ? {
                    id: docType.id,
                    code: docType.code,
                    abbrevation: docType.abbrevation
                  }
                : null,

              lockDocType: true,
              lockControlNo: true
            }
          ]}
          onUploadSuccess={onSuccess}
        />
      </Box>
    </Dialog>
  );
}
